import { React, useState, useEffect } from "react";
import FotoSeg1 from "../../assets/img/brand/FotoSeg1.png";
import FotoSeg2 from "../../assets/img/brand/FotoSeg2.png";
import FotoSeg3 from "../../assets/img/brand/FotoSeg3.png";
import FotoSeg4 from "../../assets/img/brand/FotoSeg4.png";
import FotoSeg5 from "../../assets/img/brand/FotoSeg5.png";
import FotoSeg6 from "../../assets/img/brand/FotoSeg6.png";
import FotoSeg7 from "../../assets/img/brand/FotoSeg7.png";
import FotoSeg8 from "../../assets/img/brand/FotoSeg8.png";
import FotoSeg9 from "../../assets/img/brand/FotoSeg9.png";
import FotoSeg10 from "../../assets/img/brand/FotoSeg10.png";

const RandomImageComponent = (props) => {
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
  const [randomImages, setRandomImages] = useState([]);

  const obtenerImagenesAleatoriasUnicas = (cantidad) => {
    const imagenesUnicas = [];
    const todasLasImagenes = [
      {
        foto: FotoSeg1,
        id: 1,
      },
      {
        foto: FotoSeg2,
        id: 2,
      },
      {
        foto: FotoSeg3,
        id: 3,
      },
      {
        foto: FotoSeg4,
        id: 4,
      },
      {
        foto: FotoSeg5,
        id: 5,
      },
      {
        foto: FotoSeg6,
        id: 6,
      },
      {
        foto: FotoSeg7,
        id: 7,
      },
      {
        foto: FotoSeg8,
        id: 8,
      },
      {
        foto: FotoSeg9,
        id: 9,
      },
      {
        foto: FotoSeg10,
        id: 10,
      },
    ];

    while (imagenesUnicas.length < cantidad) {
      const imagenAleatoria =
        todasLasImagenes[Math.floor(Math.random() * todasLasImagenes.length)];
      if (!imagenesUnicas.includes(imagenAleatoria)) {
        imagenesUnicas.push(imagenAleatoria);
      }
    }

    return imagenesUnicas;
  };
  useEffect(() => {
    const imagenesAleatorias = obtenerImagenesAleatoriasUnicas(5); // Cambia el número según tus necesidades
    setRandomImages(imagenesAleatorias);
  }, []);

  const informaImage = (index) => {
    props.sendImage(index);
    setImagenSeleccionada(index);
  };
  return (
    <div>
      {randomImages.map((image, index) => (
        <img
          key={index} //0,1,2,3,4
          className={imagenSeleccionada === image.id ? "productoselec" : ""}
          onClick={() => {
            informaImage(image.id);
          }}
          src={image.foto}
          id={image.id}
          alt={`Image ${index}`}
          style={{
            height: "80px",
            width: "80px",
            cursor: "pointer",
            margin: "30px",
          }}
        />
      ))}
    </div>
  );
};

export default RandomImageComponent;
